import Entity from './entity'
export default class Floor extends Entity<number>{
    password:string;
}